import { createContext } from 'react';
export const SideNavigationContext = createContext({
  activeRoute: '',
  setActiveRoute: () => {},
  isCollapsed: false,
  expand: () => {},
  collapse: () => {}
});